import { SocialFacebook } from '@/components/elements/icons/social-facebook';
import { SocialYouTube } from '@/components/elements/icons/social-Instagram';
import { SocialTwitter } from '@/components/elements/icons/social-twitter';
import { SocialInstagram } from '@/components/elements/icons/social-youtube';
import StoreLinkAlt from '@/components/elements/StoreLink';
import { Flex, Heading, Link, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import React from 'react';

const CallToAction = () => {
  const { t } = useTranslation(`common`);
  return (
    <Flex id="cta" direction="column" textAlign="center" justify="center">
      <Heading mb={[8, null, 12]} as="h2" size="4xl">
        {t(`call_to_action.header`)}
      </Heading>
      <Text mb={[12, null, 16]} fontSize={[`md`, null, `2xl`]}>
        {t(`call_to_action.lead`)}
      </Text>
      <Flex mb={[12, null, 16]} justify="center">
        <StoreLinkAlt
          href="https://apps.apple.com/tr/app/voltran-app/id1567581311"
          type="ios"
        />
        <StoreLinkAlt
          href="https://play.google.com/store/apps/details?id=com.voltran.app.voltran"
          type="android"
        />
      </Flex>
      <Heading as="h3" fontSize={[`md`, null, `2xl`]}>
        {t(`call_to_action.social_networks`)}
      </Heading>
      <Flex mt={[6, null, 9]} color="brand.500" justify="center" align="center">
        <Link
          aria-label="instagram"
          mx={[4, null, 6]}
          variant="unstyled"
          href="https://www.instagram.com/voltranapp/"
          target="_blank"
          rel="nofollow"
        >
          <SocialInstagram boxSize={[5, null, 8]} />
        </Link>
        <Link
          aria-label="facebook"
          mx={[4, null, 6]}
          variant="unstyled"
          href="https://www.facebook.com/voltran.app.9"
          target="_blank"
          rel="nofollow"
        >
          <SocialFacebook boxSize={[5, null, 8]} />
        </Link>
        <Link
          aria-label="youtube"
          mx={[4, null, 6]}
          variant="unstyled"
          target="_blank"
          rel="nofollow"
          href="https://www.youtube.com/channel/UCByTtFOtl1h05Hbk_bEu-7w"
        >
          <SocialYouTube boxSize={[5, null, 8]} />
        </Link>
        <Link
          aria-label="twitter"
          mx={[4, null, 6]}
          variant="unstyled"
          href="https://twitter.com/AppVoltran"
          target="_blank"
          rel="nofollow"
        >
          <SocialTwitter boxSize={[5, null, 8]} />
        </Link>
      </Flex>
    </Flex>
  );
};

export default CallToAction;
